import { appendQueryParameters } from '@flowio/web-sdk';

const forEach = require('lodash/forEach');
const find = require('lodash/find');
const cache = require('./cache');
const localizeElement = require('./utilities/tags/localize-element');
const localizeEach = require('./utilities/tags/localize-each');
const getAttributes = require('./utilities/tags/get-attributes');
const revealNestedTags = require('./utilities/tags/reveal-nested-tags');
const session = require('@flowio/session');
const { getFeatureKeys } = require('./features');
const request = require('@flowio/request');
const config = require('./config');
const isEmpty = require('lodash/isEmpty');
const inRange = require('lodash/inRange');
const constants = require('./constants/index').default;
/**
 * Get the correct object depending on the parameters provided.
 * @param  {String} orderId   The order to look up first
 * @param  {String} orderLine Optional. Return data for an order line item
 *                            instead of the order itself
 */
function getDataForSelector(orderId, orderLine) {
  const localizedOrder = cache.getCache().localizedOrders.getById(orderId);
  if (localizedOrder && orderLine) {
    return find(localizedOrder.lines,
      line => line.variant_id.toString() === orderLine.toString());
  }

  return localizedOrder;
}

/**
 * Find all attributes on the page with the `flow-order` attribute and
 * localize those elements.
 */
function localizeOrders() {
  const orderElements = window.document.querySelectorAll('[flow-order]');

  forEach(orderElements, (orderElement) => {
    const attributes = getAttributes(orderElement);
    const data = getDataForSelector(attributes.id, attributes.orderLine);

    if (attributes.each) {
      localizeEach(orderElement, attributes, data);
    } else {
      localizeElement(orderElement, attributes, data);
    }
  });

  revealNestedTags();
}

function getOrderUrl(options = {}) {
  const { checkoutId, orderNumber } = options;
  const sess = session.getSession().id;
  const prefix = config.SHOPIFY_CHECKOUT_PATH_PREFIX;
  const withUrlParams = (url, params) => appendQueryParameters(url, params);

  //
  // Current Checkouts resource support
  //
  if (checkoutId) {
    return withUrlParams(`${prefix}/checkouts/${checkoutId}`, {
      flow_session_id: sess,
      flow_organization: config.FLOW_ORGANIZATION,
    });
  }

  //
  // Legacy support for organization based URL
  //
  if (isEmpty(orderNumber)) {
    return undefined;
  }

  const url = `${prefix}/${config.FLOW_ORGANIZATION}/checkout/${orderNumber}/contact-info`;
  return withUrlParams(url, {
    flow_session_id: session.getSessionId(),
  });
}

function postCheckouts(form) {
  return new Promise((resolve, reject) => {
    const url = `${constants.FLOW_API_HOST}/checkouts`;
    request.authenticated(
      {
        url,
        method: 'POST',
        data: form,
      },
      (status, response) => {
        if (inRange(status, 200, 300)) {
          resolve(response);
        } else {
          reject(response);
        }
      },
    );
  });
}

function getCheckoutByOrderNumber(orderNumber) {
  const organization = config.FLOW_ORGANIZATION;
  return postCheckouts({
    discriminator: 'order_number',
    organization,
    order_number: orderNumber,
    feature_keys: getFeatureKeys(),
  });
}

function getCheckoutByOrderForm(orderForm) {
  const organization = config.FLOW_ORGANIZATION;
  return postCheckouts({
    discriminator: 'order',
    organization,
    order: orderForm,
    feature_keys: getFeatureKeys(),
  });
}

function localize() {
  localizeOrders();
}

module.exports = {
  localize,
  localizeOrders,
  getOrderUrl,
  postCheckouts,
  getCheckoutByOrderNumber,
  getCheckoutByOrderForm,
};



// WEBPACK FOOTER //
// ./static/js/v0/orders.js